import React from "react";
import { createRootRoute, Outlet, ScrollRestoration } from "@tanstack/react-router";
import { SiteHeader, SiteFooter } from "../components/SiteShell";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <SiteHeader />
      <Outlet />
      <SiteFooter />
      <ScrollRestoration />
    </>
  );
}
